import React from 'react';
import PropTypes from 'prop-types';
const SmoothScrollCarousel = ({
  children,
  bannerModifier,
  itemsPerRow,
  autoScrollTimer,
  numberOfCards
}) => {
  const wrapperClassName = `cards-carousel-smooth${bannerModifier}`;
  const contentClassName = `cards-carousel--content smooth-scroll items-per-row-${itemsPerRow}`;
  const animationTime = autoScrollTimer * numberOfCards / 1000;
  const animationDuration = `${animationTime < 1 ? 1 : animationTime}s`;
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: contentClassName,
    style: {
      animationDuration
    }
  }, children), /*#__PURE__*/React.createElement("div", {
    className: contentClassName,
    style: {
      animationDuration
    }
  }, children));
};
SmoothScrollCarousel.propTypes = {
  bannerModifier: PropTypes.string,
  itemsPerRow: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  autoScrollTimer: PropTypes.number,
  numberOfCards: PropTypes.number
};
SmoothScrollCarousel.defaultProps = {
  itemsPerRow: 0,
  bannerModifier: '',
  children: [],
  autoScrollTimer: 0,
  numberOfCards: 1
};
export default SmoothScrollCarousel;
//# sourceMappingURL=SmoothScrollCarousel.js.map